import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Drug, MedicalConsultation, MedicalTest, CartQuantityItem, Order } from '../../models';
import {CartService, DataService, MedicalTestService } from '../../services';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})

export class OrderDetailsComponent implements OnInit {
  orderDetails: (MedicalTest | Drug)[];
  order: Order;
  totalPrice: number;
  cartItems: (MedicalTest | Drug)[] = [];
  addConsultation: boolean;
  isReOrderConsultation: boolean = false;
  consultationAmount: number;
  medicalTestQuantity: { [productId: number]: number } = {};
  medicalTestQuantitiesAdded: CartQuantityItem[] = [];
  productQuantities: number[] = [];
  itemPrices: number[] = [];

  constructor(
    private cartService: CartService,
    private dataService: DataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.dataService.getLocalDataToView().subscribe(dataToView => {
      if (dataToView !== null) {
        this.order = dataToView as Order;
        this.addConsultation = !!this.order.medical_consultation;
        if (this.order.medical_tests && this.order.medical_tests.length > 0) {
          this.orderDetails = this.order.medical_tests as MedicalTest[];
        } else if (this.order.drugs && this.order.drugs.length > 0) {
          this.orderDetails = this.order.drugs as Drug[];
        }
        this.productQuantities = this.order.quantity ?? [];
        this.itemPrices = this.orderDetails.map((item, index) => {
          if ('price' in item) {
            const quantity = this.productQuantities[index] || 1;
            return Number(item.price) * quantity;
          } else {
            const quantity = this.productQuantities[index] || 1;
            const selectedTypeId = this.order.selected_quantity_type_ids?.[index];
            const drug = item as Drug;
            const selectedQuantityType = drug.quantity_types?.find(qt => qt.id === selectedTypeId);
            const pricePerUnit = Number(selectedQuantityType?.selling_price) || 0;
            return pricePerUnit * quantity;
          }
        });
      } else {
        this.router.navigate(['/dashboard']);
      }
    });
    this.dataService.getLocalMedicalConsultationAmount().subscribe(amount =>
      this.consultationAmount = Number(amount) || 0
    );
    this.cartService.getCartProducts().subscribe(cartItems => this.cartItems = cartItems);
  }

  toggleConsultation(event: Event) {
    this.isReOrderConsultation = !this.isReOrderConsultation; 
    this.dataService.saveLocalAddConsultationStatus(this.isReOrderConsultation);
  }

  addToCart(item: MedicalTest | Drug, index: number) {
    const cartHasMedicalTest = this.cartItems.some(cartItem => !('country_of_origin' in cartItem));
    const cartHasDrug = this.cartItems.some(cartItem => ('country_of_origin' in cartItem));
    const isDrug = 'country_of_origin' in item;
    if ((isDrug && cartHasMedicalTest) || (!isDrug && cartHasDrug)) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'You can only add either a medical test or a drug to the cart at a time.',
        confirmButtonColor: '#f37b7b',
      });
      return;
    }
    if (isDrug) {
      const drug = item as Drug;
      const selectedTypeId = this.order.selected_quantity_type_ids?.[index];
      const selectedQuantityType = drug.quantity_types?.find(qt => qt.id === selectedTypeId);
      this.dataService.addProductToCart(drug, selectedQuantityType);
    } else {
      this.dataService.addProductToCart(item);
    }
  }

  MedicalTestInCart(medicalTest: MedicalTest): boolean {
    return this.cartItems.some(item => item.id === medicalTest.id);
  }

  goToCart() {
    this.router.navigateByUrl('cart');
  }
}
